<template>
    <t-config-provider>
        <div class="app CGText-Regular" v-if="isWeixin()">
            <router-view v-slot="{ Component }">
                <keep-alive>
                    <component :is="Component" v-if="route.meta.keepAlive" :key="route.fullPath" />
                </keep-alive>
                <component :is="Component" v-if="!route.meta.keepAlive" :key="route.fullPath" />
            </router-view>
            <!-- 隐藏加载雪碧图 -->
            <img src="@/assets/images/changbao_xuebi.png" style="display: none;">
        </div>
    </t-config-provider>
</template>
<script setup>
import { reactive, watch, ref, computed, onMounted, onBeforeUnmount } from "@vue/runtime-core";
import { useRoute, useRouter } from "vue-router";
import { CGAppWebReady } from "@/utils/appShare";
import { wxInit, wxShare } from "@/utils/wxShare";
import { isApp, isWeixin, getQueryString } from "@/utils/common"
import { appCode, doShare } from "@/utils/api.js";
import { useUserStore, useSettingStore } from "@/store";
import { Toast, Dialog } from "tdesign-mobile-vue";

const route = useRoute();
const userStore = useUserStore();
const userSetting = useSettingStore();



let share_title = "常宝666，光影过大年";
let share_summary = "点击查看";
let share_img = "https://hd.netfishing.cn/cb666/logo.png";


const share_link = computed(() => {
    const base = window.location.origin + window.location.pathname + "#/";
    return userStore.id ? `${base}?shareUser=${userStore.id}` : base;
});



function AppInit() {
    CGAppWebReady().then(async () => {
        console.log('初始化成功')
        try {
            const { data } = await appCode();
            cgapp.config({
                client_id: data.client_id,
            });
            cgapp.ready(() => {
                cgapp.setShareData({
                    type: '',
                    data: {
                        title: share_title,
                        summary: share_summary,
                        share_link: share_link.value,
                        share_img: share_img,
                        mini_program_id: '',
                        mini_program_path: '',
                        succ_callback: '',
                        fail_callback: '',
                    },
                    success: () => {
                        console.log('分享成功')
                    },
                    fail: () => {
                        console.log('分享失败')
                    }
                });
                cgapp.checkSession({
                    success: (res) => {
                        try {
                            const localSessionFlag = window.localStorage.getItem("sessionFlag");
                            if (userStore.getToken && localSessionFlag && localSessionFlag !== res.sessionFlag) {
                                userStore.resetInfo();
                            }
                            window.localStorage.setItem("sessionFlag", res.sessionFlag);
                            if (userStore.isLogin) {
                                //APP登录且有token,token保存在localStorage中，但是可能过期,调用下获取用户信息，401则会刷新页面了
                                try {
                                    // userStore.setUser()

                                }
                                catch (err) {
                                    console.log(err)
                                }
                            }
                        } catch (e) {
                            console.error('localStorage 操作失败，执行清除token', e);
                            userStore.resetInfo();
                        }
                    },
                    fail: () => {
                        //未登录 统一清除token 防止退出后 token也保存
                        userStore.resetInfo();
                        console.log('App未登录');
                    },
                });
            })
        }
        catch (err) {
            console.log(err)
        }

    }).catch((error) => {
        console.error('初始化失败:', error);
    })

}



const getShareUser = () => {
    const reg = new RegExp("(^|&|\\?)shareUser=([^&]*)(&|$)");
    // 优先检查 hash 中的 query (Vue Hash 模式参数通常在这里)
    let r = window.location.hash.split('?')[1]?.match(reg);
    if (r != null) return decodeURIComponent(r[2]);
    // 其次检查 search 中的 query
    r = window.location.search.substr(1).match(reg);
    if (r != null) return decodeURIComponent(r[2]);
    return null;
}

onMounted(() => {

    // if (isApp()) {
    //     // AppInit()
    // } else
    if (isWeixin()) {
        wxInit()
        wxShare(share_title, share_summary, share_img, share_link.value);
        const shareUser = getShareUser();
        if (shareUser) {
            doShare(shareUser)
        }
    } else {
        Dialog.alert({
            title: '提示',
            content: '请在微信中打开此页',
            confirmBtn: '确定',
            onConfirm: () => {

            }
        })
    }

    // 已登录则立即获取 setting 和用户信息（每次刷新都重新获取）
    if (userStore.isLogin) {
        userStore.setUser().catch(e => console.warn('获取用户信息失败', e));
        userSetting.getSetting().catch(e => console.warn('获取setting失败', e));
    }

    // 用户登录后 ID 变化，重新设置分享数据
    watch(() => userStore.id, (newId) => {
        if (!newId) return;
        if (isApp()) {
            // APP 环境，重新调用 setShareData
            try {
                cgapp.setShareData({
                    type: '',
                    data: {
                        title: share_title,
                        summary: share_summary,
                        share_link: share_link.value,
                        share_img: share_img,
                    },
                });
            } catch (e) {
                console.warn('重设分享数据失败', e);
            }
        } else if (isWeixin()) {
            wxShare(share_title, share_summary, share_img, share_link.value);
        }
    });

    // 用户从未登录变为登录后，自动拉取 setting
    watch(() => userStore.token, (newToken) => {
        if (newToken) {
            userStore.setUser().catch(e => console.warn('获取用户信息失败', e));
            userSetting.getSetting().catch(e => console.warn('获取setting失败', e));
        }
    });
});

onBeforeUnmount(() => {

});
</script>


<style lang="less">
.app {
    position: relative;
    margin-left: auto !important;
    margin-right: auto !important;
    margin: 0 auto;
    font-size: 16px;
    background-color: #fff;
    min-height: 100vh;
    box-shadow: 0 0 0 1px rgba(74, 114, 180, 0.1);
    max-width: 375px;
    font-family: 'Alibaba PuHuiTi 3.0';
}

.container {
    min-height: 100vh;
}


.w {
    width: 94%;
    margin: 0 auto;
}

.t-dialog__body ::-webkit-scrollbar {
    display: none;
}

.text-ellipsis-2 {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
}

.t-popup--bottom {
    padding-bottom: 0;
}
</style>
